import { atom } from "recoil";
import TicketingModel from "../Models/TicketingModel";
export const ticketingSate = atom({
  key: "ticketingSate", // unique ID (with respect to other atoms/selectors)
  default: new TicketingModel(), // default value (aka initial value)
});
